export default "__VITE_ASSET__D_8BflVO__"